import type { ProductVendorProps } from '@components/ProductVendor';
import { useProductItemThemeSettings } from '@providers/ThemeProvider/Provider/ProductItemThemeSettings';
import { useMemo } from 'react';

export type ProductVendorPropsMapSettings = Pick<
  ProductVendorProps,
  'fontFamily' | 'color' | 'fontSize' | 'fontStyle' | 'textAlign' | 'textTransform'
>;

export const useConnectProductVendor = () => {
  const settings = useProductItemThemeSettings();
  const productVendorSettings = settings.productInfo?.elements?.vendor;

  const props: ProductVendorPropsMapSettings = useMemo(() => {
    return productVendorSettings || {};
  }, [productVendorSettings]);

  return {
    props,
  };
};
